export const _en = {
    addButton: {
        label: "Add organization"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add organization"
        }
    }

};


export const _fr = {
    addButton: {
        label: "Compagnie"
    },
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    modal: {
        add: {
            title: "Ajout d'une compagnie"
        }
    }
};